import { reduxStore } from "../../stores/reduxStore";
import { logRequest, patch } from "../../stores/slices/captchaSlice";
import { whenTrue } from "../../util/whenTrue";
import { grecaptchaExecute, isCaptchaLoaded } from "./ReCaptcha";
import { isCaptchaEnabled } from "./isCaptchaEnabled";

let inFlight: Promise<void> | null = null;

const hasError = (): boolean => reduxStore.getState().captcha.error;

const acquireToken = async (): Promise<void> => {
  reduxStore.dispatch(patch({ error: false }));

  await whenTrue(() => isCaptchaLoaded() || hasError());

  if (hasError()) {
    throw new Error("toast.captchaUnavailable");
  }

  grecaptchaExecute();

  await whenTrue(
    () => reduxStore.getState().captcha.token !== null || hasError()
  );

  if (hasError()) {
    throw new Error("toast.captchaUnavailable");
  }
};

export const solveCaptcha = async (request: RequestInfo): Promise<void> => {
  const path = String(request);

  if (!isCaptchaEnabled(reduxStore.getState()) || !path.includes("/search")) {
    return;
  }

  if (!inFlight) {
    inFlight = acquireToken().finally(() => {
      inFlight = null;
    });
  }

  await inFlight;

  const action = logRequest(path);
  reduxStore.dispatch(action);
};

/**
 * @see docs/worklog/TW-837-captcha-combo-blocked/rfc.md
 * @see docs/worklog/TW-837-captcha-combo-blocked/tfc.md
 */
